<template>

  <BasicLayout>

    <div v-if="!creamMode">

      <!-- SEARCH -->
      <Search :searching="searching"
              @search="search"
              @closeSearch="searching = false"
              @clearSearch="clearSearch"/>

      <div class="elevation-2">

        <!-- TOOLBAR -->
        <v-toolbar flat="flat">
          <v-toolbar-title>Videos</v-toolbar-title>
          <v-flex class="ml-5" md3="md3">
            <v-text-field v-show="!loading && !searching"
                          v-model="quickSearchID"
                          placeholder="Search by ID"
                          :clearable="true"></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-icon v-if="!searching"
                  class="mr-2"
                  title="Show the search"
                  @click="searching = true">mdi-magnify</v-icon>
          <v-icon v-if="pagination.totalItems"
                  title="Cream mode"
                  @click="creamPopupDisplayed = true">mdi-pot-mix</v-icon>
        </v-toolbar>

        <!-- TABLE -->
        <Table :headers="headers"
               :items="items"
               :pagination="pagination"
               :paginationOptions="paginationOptions"
               :totalItems="pagination.totalItems"
               :loading="loading"
               @edit="toggleEdit"
               @del="del"
               @suspend="toggleSuspendConfirm"
               @unsuspend="toggleSuspendConfirm"
               @paginationUpdate="paginationUpdate"/>

        <!-- EDIT -->
        <Dialog :dialog="dialog"
                :dialogState="'edit'"
                :currentEditedVideo="editedItem"
                :errorMessage="errorMessage"
                @dialogClosed="close"
                @editVideo="editVideo"/>

      </div>
    </div>

    <!-- CONFIRM SUSPEND VIDEO -->
    <ConfirmPopup :isActive="suspendConfirmToggled"
                  :title="suspendConfirmVideo && suspendConfirmVideo.suspended ? 'Unsuspend this video ?' : 'Suspend this video ?'"
                  :cancelButtonText="'Cancel'"
                  :confirmButtonText="suspendConfirmVideo && suspendConfirmVideo.suspended ? 'Unsuspend' : 'Suspend'"
                  @cancel="cancelSuspendConfirm"
                  @confirm="suspendConfirmVideo && suspendConfirmVideo.suspended ? confirmUnsuspendConfirm() : confirmSuspendConfirm()"/>

    <!-- LOADER -->
    <LoadingPopup :displayed="loaderDisplayed"
                  :title="loaderTitle"
                  :text="loaderText"/>

    <!-- CREAM MODE SORTING SELECTION -->
    <CreamModePopup :isActive="creamPopupDisplayed"
                    :totalItems="pagination.totalItems"
                    @creamModeChosen="triggerCreamMode"
                    @cancel="creamPopupDisplayed = false"/>

    <!-- CREAM MODE -->
    <CreamMode v-if="creamMode"
               :searchParams="searchParams"
               :sortingMode="creamSortingMode"/>

  </BasicLayout>

</template>

<script>

import BasicLayout from '../layouts/BasicLayout'
import Search from '../components/videos/Search'
import Table from '../components/videos/Table'
import Dialog from '../components/videos/Dialog'
import ConfirmPopup from '../components/common/ConfirmPopup'
import LoadingPopup from '../components/common/LoadingPopup'
import CreamModePopup from '../components/CreamModePopup'
import CreamMode from '../components/CreamMode'

export default {
  name: 'VideosPage',
  components: {
    BasicLayout,
    Search,
    Table,
    Dialog,
    ConfirmPopup,
    LoadingPopup,
    CreamModePopup,
    CreamMode
  },
  data () {
    return {
      loading: false,

      items: [],

      headers: [
        {
          text: 'ID',
          value: 'id',
          sortable: false,
          width: '1%'
        },
        {
          text: 'Sport',
          value: 'sportID',
          sortable: false,
          width: '1%'
        },
        {
          text: 'Date',
          value: 'date',
          sortable: false,
          width: '1%'
        },
        {
          text: 'Author',
          value: 'authorPreferredUsername',
          sortable: false,
          width: '1%'
        },
        {
          text: 'Type',
          value: 'type',
          sortable: false,
          width: '1%'
        },
        {
          text: 'Club 1',
          value: 'club1Alias',
          sortable: false,
          width: '200px'
        },
        {
          text: 'Club 2',
          value: 'club2Alias',
          sortable: false,
          width: '200px'
        },
        {
          text: 'Views',
          value: 'hitCounter',
          sortable: false,
          width: '1%'
        },
        {
          text: 'Match',
          value: 'matchID',
          sortable: false,
          width: '1%'
        }
      ],

      quickSearchID: null,

      searching: false,
      searchParams: {},

      pagination: {
        page: 1,
        rowsPerPage: 10,
        totalItems: 0
      },
      paginationOptions: [10, 50, 100],

      dialog: null,
      editedItem: null,
      editedIndex: -1,

      suspendConfirmVideo: null,
      suspendConfirmToggled: false,

      errorMessage: '',

      loaderDisplayed: false,
      loaderTitle: null,
      loaderText: null,

      creamPopupDisplayed: false,
      creamMode: false,
      creamSortingMode: null
    }
  },
  methods: {
    loadData () {
      this.loading = true
      this.searching = false

      let params = {
        page: this.pagination.page - 1,
        pageSize: this.pagination.rowsPerPage,
        withTotalItems: true,
        avoidCache: true
      }

      if (!this.searchParams.types || this.searchParams.types.length === 0) {
        this.searchParams.types = ['summary', 'point', 'wow', 'fail']
      }

      params = {
        ...params,
        ...this.searchParams
      }

      this.$store.dispatch('searchVideos', params)
        .then(resp => {
          this.pagination.totalItems = resp.totalItems
          this.items = resp.items
          this.loading = false
        })
        .catch(() => {
          alert('Error loading videos')
          this.loading = false
        })
    },

    search (params) {
      this.pagination = {
        page: 1,
        rowsPerPage: 10,
        totalItems: 0
      }
      this.searchParams = params
      this.loadData()
    },
    clearSearch () {
      this.searchParams = {}
    },

    toggleEdit (index) {
      this.editedIndex = index
      this.editedItem = JSON.parse(JSON.stringify(this.items[index]))
      this.dialog = true
    },
    close () {
      this.dialog = false
      this.editedItem = null
      this.editedIndex = -1
      this.errorMessage = ''
    },

    editVideo (editedvideo) {
      let video = JSON.parse(JSON.stringify(editedvideo))
      if (this.checkFields(video)) {
        return
      }

      this.displayLoader({
        title: 'Editing video'
      })
      this.$store.dispatch('patchVideo', {
        id: this.items[this.editedIndex].id,
        patch: video
      })
        .then(() => {
          this.hideLoader()
          this.updateItem(this.editedIndex, video)
          this.close()
        })
        .catch(() => {
          this.hideLoader()
          alert('Error editing video')
        })
    },
    updateItem (index, patch) {
      this.items[index].matchID = patch.matchID
      this.items[index].type = patch.type
    },

    checkFields (video) {
      if (!video.type) {
        this.errorMessage = 'Please select a type'
        return true
      }

      return false
    },

    del (video) {
      this.displayLoader({
        title: 'Deleting video'
      })
      this.$store.dispatch('deleteVideo', video.id)
        .then(() => {
          this.hideLoader()
          this.loadData()
        })
        .catch(() => {
          alert('Error deleting video')
        })
    },

    toggleSuspendConfirm (video) {
      this.suspendConfirmVideo = video
      this.suspendConfirmToggled = true
    },
    cancelSuspendConfirm () {
      this.suspendConfirmVideo = null
      this.suspendConfirmToggled = false
    },
    confirmSuspendConfirm () {
      this.displayLoader({
        title: 'Suspending video'
      })
      this.$store.dispatch('patchVideo', {
        id: this.suspendConfirmVideo.id,
        patch: { suspended: true }
      })
        .then(() => {
          this.hideLoader()
          this.suspendConfirmVideo = null
          this.suspendConfirmToggled = false
          this.loadData()
        })
        .catch(() => {
          this.hideLoader()
          alert('Error suspending video')
        })
    },
    confirmUnsuspendConfirm () {
      this.displayLoader({
        title: 'Unsuspending video'
      })
      this.$store.dispatch('unsuspendVideo', this.suspendConfirmVideo.id)
        .then(() => {
          this.suspendConfirmVideo = null
          this.suspendConfirmToggled = false
          this.loadData()
        })
        .catch(() => {
          alert('Error unsuspending video')
        }).finally(() => {
          this.hideLoader()
        })
    },
    displayLoader (content) {
      this.loaderTitle = content.title || null
      this.loaderText = content.text || null
      this.loaderDisplayed = true
    },
    hideLoader () {
      this.loaderDisplayed = false
      this.loaderTitle = null
      this.loaderText = null
    },

    triggerCreamMode (sortingmode) {
      this.creamSortingMode = sortingmode
      this.creamPopupDisplayed = false
      this.creamMode = true
    },

    paginationUpdate (v) {
      if (this.pagination.page !== v.page || this.pagination.rowsPerPage !== v.rowsPerPage) {
        this.pagination = {
          page: v.page,
          rowsPerPage: v.rowsPerPage,
          totalItems: this.pagination.totalItems
        }
        this.loadData()
      }
    }
  },
  watch: {
    'quickSearchID' () {
      if (this.quickSearchID) {
        if (this.quickSearchID.length !== 20) {
          this.quickSearchID = null
          return
        }
        this.loading = true
        this.$store.dispatch('getVideo', this.quickSearchID)
          .then(resp => {
            this.items = [resp]
            this.loading = false
          })
          .catch(() => {
            this.loading = false
            alert('Error loading video')
          })
      } else {
        this.loadData()
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/pages/VideosPage.vue